import React, { useState } from 'react';
import { Box, ButtonBase, Typography, Dialog, Button } from '@mui/material';
import { images } from '../assets/images';
import { Section, Heading, Img } from './common';

const Gallery = () => {
  const [sel, setSel] = useState(null);
  return (
    <Section id="gallery" bg="#ffffff">
      <Heading title="Life on campus" text="Classrooms, laboratories and clinical practice at SBGI. Select a photo to view it larger." />
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gridAutoRows: { xs: 170, md: 230 }, gridAutoFlow: 'dense', gap: 2 }}>
        {images.gallery.map((g) => (
          <ButtonBase
            key={g.caption}
            focusRipple
            onClick={() => setSel(g)}
            sx={{
              display: 'block', position: 'relative', overflow: 'hidden', borderRadius: '10px', textAlign: 'left',
              gridColumn: { xs: g.cols > 1 ? 'span 2' : 'span 1', md: `span ${g.cols}` },
              gridRow: { xs: 'span 1', md: `span ${g.rows}` },
              '& img': { transition: 'transform 0.5s ease' },
              '&:hover img': { transform: 'scale(1.06)' },
              '&:hover .cap, &.Mui-focusVisible .cap': { opacity: 1 },
            }}
          >
            <Img src={g.src} alt={g.caption} sx={{ objectPosition: g.pos || 'center' }} />
            <Box className="cap" sx={{ position: 'absolute', inset: 'auto 0 0 0', p: 2, opacity: { xs: 1, md: 0 }, transition: 'opacity 0.3s', background: 'linear-gradient(transparent, rgba(11,46,53,0.9))' }}>
              <Typography sx={{ color: '#fff', fontWeight: 600 }}>{g.caption}</Typography>
            </Box>
          </ButtonBase>
        ))}
      </Box>

      <Dialog open={Boolean(sel)} onClose={() => setSel(null)} maxWidth="lg" fullWidth>
        {sel && (
          <Box>
            <Img src={sel.src} alt={sel.caption} sx={{ maxHeight: '75vh' }} />
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography sx={{ fontWeight: 600 }}>{sel.caption}</Typography>
              <Button onClick={() => setSel(null)}>Close</Button>
            </Box>
          </Box>
        )}
      </Dialog>
    </Section>
  );
};

export default Gallery;
